
export const PLACES_TYPE_ARRAY = ['All places', 
                                  'Night', 
                                  'Parks and gardens', 
                                  'Bar', 
                                  'Restaurant', 
                                  'Theatre', 
                                  'Cinema', 
                                  'Exposition', 
                                  'Interest point']


